import { render, staticRenderFns } from "./TestDriveOrderDetail.vue?vue&type=template&id=f55ece4a&"
import script from "./TestDriveOrderDetail.vue?vue&type=script&lang=js&"
export * from "./TestDriveOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports